var map = {
	"./images/fysical.png": 1872
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1871;


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners ^.*\/fysical\.png$
// module id = 1871
// module chunks = 147